// extracted by mini-css-extract-plugin
export var container = "_2e-0";
export var error = "_2e-9";
export var label = "_2e-5";
export var light = "_2e-6";
export var md = "_2e-3";
export var sm = "_2e-2";
export var thin = "_2e-8";
export var thinBold = "_2e-7";
export var vertical = "_2e-4";
export var xs = "_2e-1";